import { Inject, Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { WINDOW } from '@ng-web-apis/common';

import { AppStateService } from '../services/app-state.service';

@Injectable({ providedIn: 'root' })
export class RedirectToNewAppGuard implements CanActivate {
  private patterns: RegExp[] = [];
  constructor(
    @Inject(WINDOW) readonly windowRef: Window,
    private readonly appStateService: AppStateService
  ) {
    this.patterns = this.appStateService
      .getRedirectUrlsToNewApp()
      .map((url) => new RegExp(url));
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Replace this with your actual redirect logic
    if (this.isRedirectUrlToNewApp(state.url)) {
      this.windowRef.location.href = state.url;
      return false;
    }
    return true;
  }

  private isRedirectUrlToNewApp(url: string): boolean {
    return this.patterns.some((pattern) => pattern.test(url));
  }
}
